import { MasteryTypes } from "./moduleTypes"
import { ReviewGroup, Standard } from "./teacherTypes"
import { StudentAssignmentResponse } from "./studentTypes"

export const Science35Grades = ["3rd Grade", "4th Grade", "5th Grade"] as const
export type Science35GradeType = typeof Science35Grades[number]

export const Science68Grades = ["6th Grade", "7th Grade", "8th Grade"] as const
export type Science68GradeType = typeof Science68Grades[number]

export const ReviewGrades = [...Science35Grades, ...Science68Grades] as const
export type ReviewGradeType = typeof ReviewGrades[number]

export type FilterGradeLevel = {
    grade: ReviewGradeType
    isValid: boolean
}

export const LandingPageScienceProducts = ["Science 35", "Science 68", "Science 35 + 68"] as const
export type LandingPageScienceProduct = typeof LandingPageScienceProducts[number]

export type ClassMasteryPageReturn = {
    completionProgress: number
    remediationProgress: number
    classStandardMasteries: ClassStandardMastery[]
}

export type ClassStandardMastery = {
    standard: Standard
    initialMasteryResults: {
        mastery: MasteryTypes
        students: string[]
    }[]
    masteryResults: {
        mastery: MasteryTypes
        students: string[]
    }[]
}

export type StudentMasteryPageReturn = {
    completionProgress: number
    remediationProgress: number
    studentMasteries: StudentStandardMastery[]
}

export type StudentMasteryResult = {
    mastery: MasteryTypes
    submissionIds: string[]
    grade: number
}

export type StudentStandardMastery = {
    studentId: string
    standard: Standard
    initialMasteryResult: StudentMasteryResult
    masteryResults: StudentMasteryResult[]
    recentGrade: number | null
}

export type StudentReviewAssignmentsPageReturn = {
    completedCoreIdeasCount: number
    allCoreIdeasCount: number
    lastCompletedReviewAssignment: StudentReviewAssignment | null
    reviewAssignments: StudentReviewAssignment[]
    availableFilterGrades: FilterGradeLevel[]
}

export type StudentReviewAssignment = {
    name: string
    label?: string
    assignment: StudentAssignmentResponse
    standardSubtopic: string
    pretestAssignmentId: string
    lessonAssignmentId: string
    knowledgeCheckAssessmentId: string | null
    pretestGrade: number | null
    lessonGrade: number | null
    lessonViewed: boolean
    block: BlockType
}

export const AllBlocks = [
    "Science 35", "Science 68", "Science 21-35", "Science 35 Michigan",
    "Science Bio", "Science ESS", 
    "Science 35 NY Grade 3", "Science 35 NY Grade 4", "Science 35 NY Grade 5", 
    "Science 35 National Grade 3", "Science 35 National Grade 4", "Science 35 National Grade 5",
] as const
export type BlockType = typeof AllBlocks[number] | (string & {})

export const BlocksWithSTEMCopyright: readonly BlockType[] = [
    "Science Bio", "Science ESS", "Science 35 Michigan", "Science 68"
]

export const AllScience35Blocks: readonly BlockType[] = [
    "Science 21-35",
    "Science 35",
    "Science 35 Michigan",
    "Science 35 National",
    "Science 35 National Grade 3",
    "Science 35 National Grade 4",
    "Science 35 National Grade 5",
    "Science 35 NY Grade 3",
    "Science 35 NY Grade 4",
    "Science 35 NY Grade 5",
]

export const FullScience35Blocks: readonly BlockType[] = [
    "Science 21-35",
    "Science 35",
    "Science 35 Michigan",
    "Science 35 National",
]

export const EnableReadingLevelBlocks: readonly BlockType[] = [
    "Science 35 National Grade 3",
    "Science 35 National Grade 4",
    "Science 35 National Grade 5",
    "Science 35 NY Grade 3",
    "Science 35 NY Grade 4",
    "Science 35 NY Grade 5",
]

export interface Block {
    id: string
    block: BlockType
    reviewGroups?: ReviewGroup[]
}
